import moment from "moment";

export class CurrentCredentials{
    public static username:string="";
    public static password:string="";
    public static personnelFullName:string="";
    public static personnelCode:string="";
    public static fiscalPeriodStart : moment.Moment;
    public static macAddresses : string[] = [];
}